export enum ProductStatus {
  NEW = 'NEW',

  ACTIVE = 'ACTIVE',

  INACTIVE = 'INACTIVE',
}
